const ReactDOM = require('react-dom');

module.exports = function getContainer(container, defaultContainer) {
  // eslint-disable-next-line no-param-reassign
  container = typeof container === 'function' ? container() : container;

  // eslint-disable-next-line react/no-find-dom-node
  return ReactDOM.findDOMNode(container) || defaultContainer;
};
